<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
            <div class="flex-header">
                <student-header [pageTitle]="'Documents'" [showYearSelector]="false"></student-header>
            </div>

            <div class="flex-content">
                <div style="text-align:center;" *ngIf="studentDocumentsLength == 0 && isBusy==false" translate>No
                    Documents
                    data
                    exists for student.
                </div>
                <div style="height:0px; overflow:auto;flex-grow:1;" *ngIf="studentDocumentsLength > 0">
                    <!-- Angular Material table definition -->
                    <mat-table #table [dataSource]="angularMatData" matSort matSortDisableClear id="SDdataTable"
                        matSortActive="CreatedOn" matSortDirection="desc" aria-label="Student Documents Table"
                        tabindex="0">
                        <!-- Individual column definitions -->
                        <ng-container matColumnDef="Name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:200px;margin-right:20px;">
                                <span translate>File Name</span>
                                <filter [data]="angularMatData" columnName="Name" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:200px;margin-right:20px;">
                                <a (click)="viewAttachment(SD)" class="link">{{SD.Name}}</a>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Notes">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:200px;margin-right:20px;">
                                <span translate>Description</span>
                                <filter [data]="angularMatData" columnName="Notes" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:200px;margin-right:20px;">{{SD.Notes}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DocumentType">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:150px;margin-right:20px;">
                                <span translate>Document Type</span>
                                <filter [data]="angularMatData" columnName="DocumentType" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:150px;margin-right:20px;">
                                {{SD.DocumentType}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DocumentFor">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:150px;margin-right:20px;">
                                <span translate>For</span>
                                <filter [data]="angularMatData" columnName="DocumentFor" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:150px;margin-right:20px;">{{SD.DocumentFor}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="FileType">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:100px;margin-right:20px;">
                                <span translate>File Type</span>
                                <filter [data]="angularMatData" columnName="FileType" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:100px;margin-right:20px;">{{SD.FileType}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="V10Notes">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:200px;margin-right:20px;">
                                <span translate>Description/Comments</span>
                                <filter [data]="angularMatData" columnName="Notes" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:200px;margin-right:20px;">{{SD.Notes}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="CreatedOn">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:100px;margin-right:20px;">
                                <span *ngIf="!V10" translate>Added</span>
                                <span *ngIf="V10" translate>Created</span>
                                <filter [data]="angularMatData" columnName="CreatedOn" dataType="date"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:100px;margin-right:20px;">
                                {{SD.CreatedOn | date:'MM/dd/yy'}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="CreatedBy">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:100px;margin-right:20px;">
                                <span translate>Added by</span>
                                <filter [data]="angularMatData" columnName="CreatedBy" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:100px;margin-right:20px;">{{SD.CreatedBy}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="RecentAccessHistory">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:260px;margin-right:20px;">
                                <span translate>Access History</span>
                                <filter [data]="angularMatData" columnName="RecentAccessHistory" dataType="string">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="min-width:260px;margin-right:20px;">
                                <a id="lnkStudent{{SD.RecentAccessHistory}}" class="link"
                                    (click)="studentAccessHistoryClick(SD)">
                                    {{SD.RecentAccessHistory | date: 'MM/dd/yy hh:mm a'}}
                                </a>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Actions">
                            <mat-header-cell *matHeaderCellDef style="max-width: 100px;min-width: 100px;"
                                class="print-ignore">
                                Actions
                            </mat-header-cell>
                            <mat-cell *matCellDef="let doc; let i = index;" class="print-ignore"
                                style="max-width: 100px;min-width: 100px;">
                                <tyl-mat-menu id="actionMenu{{i}}" image="actions.png" *ngIf="canAddAll">

                                    <button id="edit{{i}}" mat-menu-item class="menuItem" (click)="editClick(doc)">
                                        Edit
                                    </button>
                                    <mat-divider>
                                    </mat-divider>
                                    <button id="delete{{i}}" mat-menu-item class="menuItem"
                                        (click)="deleteDocumentClick(doc)">
                                        Delete
                                    </button>

                                </tyl-mat-menu>
                                <tyl-mat-menu id="actionMenu{{i}}" image="actions.png"
                                    *ngIf="(!canAddAll && canAdd && getPermisionCategory(doc.PermissionsCategory))">

                                    <button id="edit{{i}}" mat-menu-item class="menuItem" (click)="editClick(doc)">
                                        Edit
                                    </button>
                                    <mat-divider>
                                    </mat-divider>
                                    <button id="delete{{i}}" mat-menu-item class="menuItem"
                                        (click)="deleteDocumentClick(doc)">
                                        Delete
                                    </button>

                                </tyl-mat-menu>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="SDdataHeader">
                        </mat-header-row>
                        <!-- Data rows -->
                        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="SDdataRow{{i}}"
                            tabindex="0" [attr.aria-label]="getAriaRow(row)"
                            style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple>
                        </mat-row>
                    </mat-table>
                </div>
            </div>
        </tyl-kendo-pdf-export>
        <div class="flex-footer">
            <div class="flex-footer-left">
                <tyl-button image="add.png" label="Add Document" *ngIf="canAdd || canAddAll"
                    (clickEvent)="addAttachmentClick()"></tyl-button>
                <tyl-button [image]="filtered ? 'filter yellow.png' : 'filter.png'" label="Filter"
                    (click)="showFilterClick()">
                </tyl-button>
            </div>
            <div class="flex-footer-middle" style="align-items: center;">
                <filter-notification [filtered]="filtered || angularMatData.isFiltered()"
                    (clearFilter)="clearFilterFromFooter()"></filter-notification>
            </div>
            <div class="flex-footer-right">
                <tyl-checkbox id='chkShowFormsforEntireFamily' name='chkShowFormsforEntireFamily'
                    style="margin-right: 16px;" [(checked)]='showFormsForEntireFamily'
                    *ngIf="userType == 1"
                    (change)=" showFormsForEntireFamily = $event; showFormsForEntireFamilyChange(showFormsForEntireFamily)">
                    Show entries for entire family
                </tyl-checkbox>
            </div>
        </div>

    </div>


    <!-- Filter Panel -->
    <div *ngIf="showFilter" class="filter-body">

        <div class="menuHeader" translate>
            Filter
        </div>

        <div class="menuBody">

            <!-- File Name -->
            <label translate>File Name</label>
            <tyl-form-field>
                <input matInput name="fileNameFilter" id="filterFileNameField" [ngModel]="filter.fileName"
                    (ngModelChange)="filter.fileName = $event; applyFilter();">
            </tyl-form-field>

            <!-- Description -->
            <label translate>Description</label>
            <tyl-form-field>
                <input matInput name="descriptionFilter" id="filterDescriptionField" [ngModel]="filter.description"
                    (ngModelChange)="filter.description = $event; applyFilter();">
            </tyl-form-field>

            <!-- Document Type -->
            <label translate>Document Type</label>
            <tyl-form-field>
                <input matInput name="documentTypeFilter" id="filterDocumentTypeField" [ngModel]="filter.documentType"
                    (ngModelChange)="filter.documentType = $event; applyFilter();">
            </tyl-form-field>

            <!-- For -->
            <label translate>For</label>
            <tyl-form-field>
                <input matInput name="forFilter" id="filterForField" [ngModel]="filter.for"
                    (ngModelChange)="filter.for = $event; applyFilter();">
            </tyl-form-field>

            <!-- Added -->
            <label translate>Added</label>
            <tyl-datepicker label="From" id="filterAddedFromField" [value]="filter.createdFrom"
                (valueChange)="filter.createdFrom = $event; applyFilter();"></tyl-datepicker>
            <tyl-datepicker label="To" id="filterAddedToField" [value]="filter.createdTo"
                (valueChange)="filter.createdTo = $event; applyFilter();"></tyl-datepicker>

            <!-- Added By -->
            <label translate>Added By</label>
            <tyl-form-field>
                <input matInput name="addedByFilter" id="filterAddedByField" [ngModel]="filter.addedBy"
                    (ngModelChange)="filter.addedBy = $event; applyFilter();">
            </tyl-form-field>

        </div>

        <div class="filter-flex-footer">

            <!-- Left Buttons -->
            <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>

            <!-- Right Buttons -->
            <div class="footerRight">
                <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
            </div>
        </div>
    </div>
</div>
